import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProducts } from '../../contexts/ProductContext';
import Button from '../common/Button';
import { useInView } from '../../hooks/useInView';
import './HeroSection.css';

const HeroSection: React.FC = () => {
  const navigate = useNavigate();
  const { setSearchTerm } = useProducts();
  const [searchValue, setSearchValue] = useState('');
  const { ref: heroRef, isInView: heroInView } = useInView<HTMLElement>({ threshold: 0.25 });

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchValue.trim()) {
      setSearchTerm(searchValue);
      navigate('/shop');
    }
  };

  const handleBrowseAll = () => {
    navigate('/shop');
  };

  return (
    <section ref={heroRef} className={`hero-section ${heroInView ? 'hero-visible' : ''}`}>
      <div className="hero-container">
        <div className="hero-content">
          <p className="hero-eyebrow">Est. Over 50 Years</p>
          <h1 className="hero-headline">Because Excellence Deserves Reward</h1>
          <p className="hero-subtext hero-subtext-primary">
            Quirke Trophies, has for over 50 years, been proud to share in the successes of our customers.
          </p>
          <p className="hero-subtext hero-subtext-secondary">
            We provide bespoke trophies, cups and memorabilia for all occasions.
          </p>
          
          <form className="hero-search" onSubmit={handleSearch}>
            <div className="hero-search-wrapper">
              <img src="/assets/images/search.png" alt="Search" className="hero-search-icon" />
              <input
                type="text"
                placeholder="Search trophies, medals, plaques..."
                className="hero-search-input"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>
          </form>

          <Button 
            variant="primary" 
            onClick={handleBrowseAll}
            className="hero-cta-button"
          >
            Browse All Products
          </Button>
        </div>

        <div className="hero-image-wrapper">
          <div className="hero-image-fade" aria-hidden="true" />
          <div className="hero-image-blur" aria-hidden="true" />
          <img 
            src="/3d00e24b-d5eb-476f-9062-268295ecc64c.png" 
            alt="Three gold trophies displayed in ascending order" 
            className="hero-image"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
